import { useNavigate, useParams } from "react-router-dom";
import { useAlert } from "../../../../../contexts/alert-context";
import { useTranslation } from "react-i18next";
import { AddressInfoDTO, ScrapDTO, ScrapInfoDTO, ContainersProspectingDTO } from "./models/scrap-DTO";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import ScrapCategoryInputAutocomplete from "../../../../../components/ScrapCategoryInputAutocomplete/ScrapCategoryInputAutocomplete";
import { useState, useEffect, ChangeEvent, useCallback, useRef } from "react";
import { unityENUM } from "../../../../../assets/enums/unit-enum";
import { periodENUM } from "../../../../../assets/enums/period-enum";
import InputMask from "react-input-mask";
import {
  ContainersTypeDTO,
  getContainersByCountryName,
} from "../../../../../services/containers-service";
import {
  getAdrressByEntityId,
  getCountryConfigById,
} from "../../../../../services/address-service";
import genericImage from "./../../../../../assets/svgs/material-list.svg";
import { CurrencyInput } from "react-currency-mask";
import CollapsibleSection from "../../../../../components/ColapseSection/CollapsibleSection";
import Expiration from "../../../../../components/Expiration/Expiration";
import { ExpirationDTO } from "../../../../../components/Expiration/models/ExpirationDTO";
import AddressSectionFields from "../../../../../components/AddressSectionFields/AddressSectionFields";
import { StatusEnum } from "../../../../../assets/enums/status-enum";
import { MaterialBidTypeEnum } from "../../../../../assets/enums/bid-type-enum";
import ScrapDealerInputAutocomplete from "../../../../../components/ScrapDealersIInputAutocomplete/ScrapDealersIInputAutocomplete";
import {
  addNewScrapAdmin,
  cancelScrapAdmin,
  fetchPartnerRequirementsTotalByCountry,
  getPrivateBidList,
  getScrapAdminById,
} from "../../../scrap-admin-service";
import uploadIcon from "../../../../../assets/svgs/upload.svg";
import {
  SparkIcon,
  SparkTable,
  SparkTableBody,
  SparkTableCell,
  SparkTableHead,
  SparkTableRow,
} from "@bosch-web-dds/spark-ui-react";

import UploadCsvModal from "../../../../../components/ImportExportCsv/UploadCsvModal/UploadCsvModal";
import { useAuth } from "../../../../../contexts/auth-context";
import ScrapDealersInvitedModalForm from "./components/scrap-dealers-invited-modal";
import { applyDecimalMask } from "../../../../../utils/formatting";
import { getScrapGeneratorInfo } from "../../../../scrap-generators/scrap-generator-service";
import { ScrapGeneratorInfoDTO } from "../../../../scrap-generators/scrap-generators-DTO";
import ScrapDealersSendMailModal from "./components/scraps-dealers-send-mail-modal";
import ImportExportCsv from "../../../../../components/ImportExportCsv/ImportExportCsv";
import GenericConfirmationModal from "../../../../../components/GenericConfirmationModal/GenericConfirmationModal";
import { DealersInvitedTableDTO } from "../../../scrap-generator-scraps-view/components/scrap-form/models/dealers-invited-DTO";
import { ScrapsCategoryInfoDTO } from "../../../scrap-category/models/scrap-category-DTO";
import { COLLECTIONS } from "../../../../../assets/enums/firebase-colections";
import {
  callFunction,
  updateFieldWithArrayUnion,
  updateOnlyFieldOfForm,
  uploadCsvFile,
} from "../../../../../services/persistence";
import { PrivateBidDTO } from "./models/private-bid-DTO";
import { sendEmailGeneratorOrDealer } from "../../../../../services/send-email-SDM";
import CTAInfoComponent from "../../../../../components/CTAInfoComponent/CTAInfoComponent";
import ScrapStorageInputAutocomplete from "../../../../../components/ScrapStorageInputAutocomplete/ScrapStorageInputAutocomplete";
import MTRTreatmentInputAutocomplete from "../../../../../components/treatmentMTRCodeAutocomplete/treatmentMTRCodeAutocomplete";
import { getScrapDealerById } from "../../../../scrap-dealers/scrap-dealers-service";
import { ScrapDealerDTO } from "../../../../scrap-dealers/scrap-dealer-DTO";
import { CountryConfigDTO } from "../../../../settings/components/Country-config/country-config-DTO";
import {
  addDaysAndTransformDateStringToDate,
  formatDateToStringYearFirst,
} from "../../../../../services/date-format";
import { transformDateFormat } from "../../../../../services/date-format";
import UploadFileOrImage from "../../../../../components/UploadFileAndImagesComponent/UploadFileOrImagesComponent";

const ScrapForm: React.FC<{ enabledUsers: string[] }> = ({ enabledUsers }) => {
  const { id, scrapId } = useParams<{ id: string; scrapId: string }>();
  const { setAlert } = useAlert();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { userDoc } = useAuth();
  const profile = userDoc?.profile;
  let data = { originId: scrapId, generatorId: scrapId };

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitted },
    setValue,
    trigger,
    getValues,
    watch,
    control,
  } = useForm<ScrapDTO>({
    defaultValues: {
      scrapInfo: {
        containers: [{ containerType: "", containerSize: "", containerQuantity: "" }],
      },
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "scrapInfo.containers",
  });


  const [isDisabled, setIsDisabled] = useState(false);
  const [idsToSend, setIdsToSend] = useState<any[]>([]);
  const [containers, setContainers] = useState<ContainersTypeDTO[]>([]);
  const [countryConfigEntity, setCountryConfigEntity] =
    useState<CountryConfigDTO>();
  const [selectedCategoryDetails, setSelectedCategoryDetails] =
    useState<ScrapsCategoryInfoDTO | null>(null);
  const [scrapAdmin, setScrapAdmin] = useState<ScrapDTO | null>(null);
  const [dealersInvited, setDealersInvited] = useState<any[]>([]);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [privateBidList, setPrivateBidList] = useState<PrivateBidDTO[]>([]);
  const [selectedImages, setSelectedImages] = useState<File[]>([]);
  const [removedFiles, setRemovedFiles] = useState<string[]>([]);
  const [selectedContainerType, setSelectedContainerType] = useState<any>("");
  const [contractValue, setContractValue] = useState<string>("");
  const [targetPrice, setTargetPrice] = useState<string>("");
  const [bidValue, setBidValue] = useState<string>("");
  const [sendMailModal, setSendMailModal] = useState(false);
  const [currentDate, setCurrentDate] = useState<string>("");
  const [selectedStatus, setSelectedStatus] = useState("TO_DEAL");
  const [showContract, setShowContract] = useState(false);
  const [currentPeriod, setCurrentPeriod] = useState("");
  const [isContractDealerDisabled, setIsContractDealerDisabled] =
    useState(false);
  const [containersList, setContainersList] = useState<ContainersProspectingDTO[]>([]);


  const [selectedUnity, setSelectedUnity] = useState("");
  const [generator, setGenerator] = useState<ScrapGeneratorInfoDTO | null>(
    null
  );
  let timer: NodeJS.Timeout;
  const [tableData, setTableData] = useState<DealersInvitedTableDTO[]>([]);
  const tableHeader = [
    `-`,
    `${t("label-invited")}`,
    `${t("label-region")}`,
    `${t("label-invitation")}`,
    `${t("label-proposed-value")}`,
    `${t("label-attachment")}`,
    `${t("label-status")}`,
  ];
  const privateBidTableHeader = [
    `${t("label-name")}`,
    `${t("label-email")}`,
    `${t("label-phone")}`,
  ];
  const [editTableModalOpen, setEditTableModalOpen] = useState(false);
  const [editTableItem, setEditTableItem] =
    useState<DealersInvitedTableDTO | null>();

  const nationalRegisterRef = useRef(null);

  const handleOpenTableModal = (rowItem: DealersInvitedTableDTO) => {
    setEditTableItem(rowItem);
    setEditTableModalOpen(true);
  };

  const getMinDate = () => {
    if (!scrapId) {
      const today = new Date();
      today.setDate(today.getDate() + 2);
      return today.toISOString().split("T")[0];
    }
  };

  function handlerMails(e: any, newId: any) {
    e.stopPropagation();
    setIdsToSend((prev) =>
      prev.filter((obj) => obj.id == newId.id).length > 0
        ? prev.filter((obj) => obj.id != newId.id)
        : [...prev, newId]
    );
  }

  const handleCloseTableModal = async (
    updatedData?: DealersInvitedTableDTO,
    submitType?: string
  ) => {
    if (updatedData) {
      if (
        updatedData.status === "WINNER" &&
        (!updatedData.proposedOriginalValue ||
          updatedData.proposedOriginalValue <= 0)
      ) {
        setAlert({
          text: t("alert-winner-must-have-price"),
          type: "error",
        });
        return;
      }
      setTableData((prevDealers) =>
        prevDealers.map((dealer) => {
          if (updatedData.status === "WINNER") {
            return dealer.id === updatedData.id
              ? {
                  ...dealer,
                  status: "WINNER",
                  proposedValue: updatedData.proposedValue,
                  proposedOriginalValue: updatedData.proposedOriginalValue,
                  attachment: updatedData.attachment,
                  inviteSended: updatedData.inviteSended,
                  inviteAccepted: updatedData.inviteAccepted,
                }
              : dealer.status === "WINNER"
              ? { ...dealer, status: " " }
              : dealer;
          } else {
            return dealer.id === updatedData.id
              ? {
                  ...dealer,
                  status: updatedData.status,
                  proposedValue: updatedData.proposedValue,
                  proposedOriginalValue: updatedData.proposedOriginalValue,
                  attachment: updatedData.attachment,
                  inviteSended: updatedData.inviteSended,
                  inviteAccepted: updatedData.inviteAccepted,
                }
              : dealer;
          }
        })
      );

      setDealersInvited((prevDealers) =>
        prevDealers.map((dealer) => {
          if (updatedData.status === "WINNER") {
            return dealer.id === updatedData.id
              ? {
                ...dealer,
                status: "WINNER",
                proposedValue: updatedData.proposedValue,
                proposedOriginalValue: updatedData.proposedOriginalValue,
                attachment: updatedData.attachment,
              }
              : dealer.status === "WINNER"
                ? { ...dealer, status: " " }
                : dealer;
          } else {
            return dealer.id === updatedData.id
              ? {
                ...dealer,
                status: updatedData.status,
                proposedValue: updatedData.proposedValue,
                proposedOriginalValue: updatedData.proposedOriginalValue,
                attachment: updatedData.attachment,
              }
              : dealer;
          }
        })
      );

      if (updatedData.status === "WINNER") {
        setValue("scrapInfo.contractDealer", "");
        navigate(`/scrap-generators-details/${id}/scraps-form/${scrapId}`);
      }
    }

    setSendMailModal(false);
    setIdsToSend([]);
    setEditTableItem(null);
    setEditTableModalOpen(false);
    fetchData();
  };

  const handleContractDealerChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const selectedDealerId = event.target.value;
    const selectedDealer = tableData.find(
      (dealer) => dealer.id === selectedDealerId
    );

    if (selectedDealer) {
      const selectedValue = selectedDealer.proposedValue;
      setContractValue(selectedValue);
      setValue("scrapContract.contractValue", selectedValue);
    } else {
      setContractValue("");
      setValue("scrapContract.contractValue", "");
    }
  };
  useEffect(() => {
    if (scrapAdmin?.scrapContract?.contractValue) {
      setContractValue(scrapAdmin.scrapContract.contractValue);
      setValue(
        "scrapContract.contractValue",
        scrapAdmin.scrapContract.contractValue
      );
    }
  }, [scrapAdmin]);

  useEffect(() => {
    if (tableData) {
      setValue("dealersInvitedTable.dealersInvitedList", tableData);
    }
    const hasWinner = tableData?.some((item) => item.status === "WINNER");
    if (
      (scrapAdmin?.scrapInfo.status !== "TO_DEAL" &&
        scrapAdmin?.scrapInfo.status !== "AWAITING_BID" &&
        scrapAdmin?.scrapInfo.status !== "DISAPPROVED" &&
        scrapAdmin?.scrapInfo.status !== "IN_BID") ||
      hasWinner
    ) {
      setShowContract(true);
    } else {
      setShowContract(false);
    }
  }, [tableData]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    const delay = 1500;
    timer = setTimeout(() => {
      fetchDealersPrivateBidList();

      const additionalDelay = 2000;
      setTimeout(() => {
        fetchDealersPrivateBidList();
      }, additionalDelay);
    }, delay);
  };

  const handleImageChange = useCallback(
    (files: File[], removedFiles: string[]) => {
      setSelectedImages(files);
      if (removedFiles.length > 0) {
        setRemovedFiles(removedFiles);
      }
    },
    []
  );

  const handleUnityChange = (event: any) => {
    const { value } = event.target;
    setSelectedUnity(t(`unityENUM.${value}`));
    setValue("scrapInfo.unity", value);
  };

  useEffect(() => {
    if (scrapAdmin?.scrapInfo.contractDealer) {
      setIsContractDealerDisabled(true);
    }
  }, [scrapAdmin]);


  useEffect(() => {
    if (scrapAdmin?.scrapInfo?.containers) {
      remove();
      scrapAdmin.scrapInfo.containers.forEach((container, index) => {
        append({
          containerType: container.containerType || "",
          containerSize: container.containerSize || "",
          containerQuantity: container.containerQuantity || "",
        });
      });
    } else {
      remove();
      append({ containerType: "", containerSize: "", containerQuantity: "" });
    }
  }, [scrapAdmin?.scrapInfo?.containers]);


  function fetchScrapData() {
    if (scrapId) {
      getScrapAdminById(scrapId).then((data) => {
        if (data) {
          if (data.scrapInfo) {
            setValue(
              "scrapInfo.tempDealer",
              data.scrapInfo.tempDealer || {
                MTRcode: "",
                name: "",
                nationalRegister: "",
              }
            );
            setOperationTemporaryStorage(
              data.scrapInfo.operationTempStorageContractedCompany
            );
            setValue(
              "scrapInfo.operationTempStorageContractedCompany",
              data.scrapInfo?.operationTempStorageContractedCompany
            );
            if (data.scrapInfo.containers && Array.isArray(data.scrapInfo.containers)) {
              setValue("scrapInfo.containers", data.scrapInfo.containers);
            } else {
              setValue("scrapInfo.containers", [{ containerType: "", containerSize: "", containerQuantity: "" }]);
            }
            setValue("scrapInfo.carrier", data.scrapInfo.carrier || "");

            setValue(
              "scrapInfo.carrier",
              data.scrapInfo.carrier || {
                MTRcode: "",
                name: "",
                nationalRegister: "",
              }
            );
            setOperationCarrier(
              data.scrapInfo.operationCarrierContractedCompany
            );
            if (data.scrapInfo) {
              setValue("scrapInfo.containerType", data.scrapInfo.containerType || "");
              setValue("scrapInfo.containerSize", data.scrapInfo.containerSize || "");
              setValue("scrapInfo.containerQuantity", data.scrapInfo.containerQuantity || "");
              if (data.scrapInfo.containers && Array.isArray(data.scrapInfo.containers)) {
                setContainersList(data.scrapInfo.containers);
              }
            }
            setValue(
              "scrapInfo.operationCarrierContractedCompany",
              data.scrapInfo?.operationCarrierContractedCompany
            );

            setValue(
              "scrapInfo.finalDestination",
              data.scrapInfo.finalDestination || ""
            );
            setOperationRecipient(
              data.scrapInfo.operationRecipientContractedCompany
            );
            setValue(
              "scrapInfo.operationRecipientContractedCompany",
              data.scrapInfo.operationRecipientContractedCompany
            );

            setValue(
              "scrapInfo.operationDate",
              data.scrapInfo.operationDate || ""
            );
            setValue("scrapInfo.status", data.scrapInfo.status || "");
            setValue(
              "scrapInfo.contractRecurrent",
              data.scrapInfo.contractRecurrent || true
            );
            setSelectedStatus(data.scrapInfo.status);

            setValue(
              "scrapInfo.contractPeriodDays",
              data.scrapInfo.contractPeriodDays || 0
            );
            setValue(
              "scrapInfo.contractPeriodDaysType",
              data.scrapInfo.contractPeriodDaysType
            );
            setUnit(data.scrapInfo.contractPeriodDaysType);

            if (data.scrapInfo.contractPeriodDays % 365 !== 0) {
              setValueRecurrent(
                parseFloat(
                  (data.scrapInfo.contractPeriodDays / 30).toFixed(2)
                ) || 0
              );
            } else {
              setValueRecurrent(
                parseFloat(
                  (data.scrapInfo.contractPeriodDays / 365).toFixed(2)
                ) || 0
              );
              setUnit(365);
            }

            setValue(
              "scrapInfo.scrapCategory",
              data.scrapInfo.scrapCategory || ""
            );
            handleCategoryChange(data.scrapInfo.scrapCategory);
            setValue("scrapInfo.codeNCM", data.scrapInfo.codeNCM || "");
            setValue(
              "scrapInfo.observationsStorage",
              data.scrapInfo.observationsStorage || ""
            );
            setValue(
              "scrapInfo.specialDescription",
              data.scrapInfo.specialDescription || ""
            );
            setValue("scrapInfo.quantity", data.scrapInfo.quantity || "");
            setQuantityMaskedValue(data.scrapInfo.quantity || "");
            setValue("scrapInfo.unity", data.scrapInfo.unity || "");
            setSelectedUnity(t(`unityENUM.${data.scrapInfo.unity}`));
            setValue("scrapInfo.period", data.scrapInfo.period || "");
            setCurrentPeriod(data.scrapInfo.period);
            setValue(
              "scrapInfo.pickUpFrequency",
              data.scrapInfo.pickUpFrequency || ""
            );
            setValue(
              "scrapInfo.responsibleShipping",
              data.scrapInfo.responsibleShipping || ""
            );
            setValue(
              "scrapInfo.containerNeeded",
              data.scrapInfo.containerNeeded
            );
            setContainerNeeded(data.scrapInfo.containerNeeded);
            setValue(
              "scrapInfo.saleableWaste",
              data.scrapInfo.saleableWaste ?? true
            );
            setSaleableWaste(data.scrapInfo.saleableWaste ?? true);
            setValue(
              "scrapInfo.containerType",
              data.scrapInfo.containerType || ""
            );
            setSelectedContainerType(data.scrapInfo.containerType || "");

            setValue(
              "scrapInfo.containerSize",
              data.scrapInfo.containerSize || ""
            );
            setValue(
              "scrapInfo.containerQuantity",
              data.scrapInfo.containerQuantity || ""
            );
            setContainerQuantityMaskedValue(
              data.scrapInfo.containerQuantity || ""
            );
            setValue(
              "scrapInfo.operationAddress",
              data.scrapInfo.operationAddress || ""
            );
            setAddress(data.scrapInfo.operationAddress);
            setSelectedContainerType(data.scrapInfo.containerType);
            setValue("scrapInfo.containerType", data.scrapInfo.containerType);
            setValue("scrapInfo.images", data.scrapInfo?.images || []);

            if (
              data.scrapInfo.status !== "TO_DEAL" &&
              data.scrapInfo.status !== "AWAITING_BID" &&
              data.scrapInfo.status !== "IN_BID"
            ) {
              setShowContract(true);
            } else {
              setShowContract(false);
            }
          }

          if (data.dealersInvitedTable) {
            setTableData(data.dealersInvitedTable.dealersInvitedList);
            setValue("dealersInvitedTable.dealersInvitedList", tableData);
          }

          if (data.scrapNegotiation) {
            setValue(
              "scrapNegotiation.targetPrice",
              data.scrapNegotiation.targetPrice || ""
            );
            setValue(
              "scrapNegotiation.salesDate",
              data.scrapNegotiation.salesDate || ""
            );
            setValue(
              "scrapNegotiation.pickUpFrequency",
              data.scrapNegotiation.pickUpFrequency || ""
            );
            setValue(
              "scrapNegotiation.bidNegotiationType",
              data.scrapNegotiation.bidNegotiationType
            );
          }

          if (data.scrapBid) {
            setValue("scrapBid.bidType", data.scrapBid.bidType || "");
            setValue("scrapBid.bidDate", data.scrapBid.bidDate || "");
            setValue("scrapBid.bidValue", data.scrapBid.bidValue || "");
            setValue(
              "scrapBid.dealersInvited",
              data.scrapBid.dealersInvited || ""
            );
            setDealersInvited(data.scrapBid.dealersInvited || "");
            setValue(
              "scrapBid.requirimentsApprovalBid",
              data.scrapBid.requirimentsApprovalBid || ""
            );
          }

          if (data.scrapContract) {
            setValue(
              "scrapInfo.contractDealer",
              data.scrapInfo.contractDealer || ""
            );
            setValue(
              "scrapContract.contractDate",
              data.scrapContract.contractDate?.split("T")?.[0] || ""
            );
            setValue(
              "scrapContract.expirationDocument.expirationDate",
              data.scrapContract.expirationDocument?.expirationDate || ""
            );
            setExpiration(data.scrapContract.expirationDocument);
            setValue(
              "scrapContract.contractValue",
              data.scrapContract.contractValue || ""
            );
            setValue(
              "scrapContract.contractIndex",
              data.scrapContract.contractIndex || ""
            );
          }

          if (data.observations) {
            setValue(
              "observations.observations",
              data.observations.observations || ""
            );
          }
          setScrapAdmin(data);
        }
      });
    }
  }

  useEffect(() => {
    fetchScrapData();
  }, [scrapId, setValue, sendMailModal, setSelectedContainerType]);

  useEffect(() => {
    if (
      scrapAdmin &&
      scrapAdmin.scrapNegotiation &&
      scrapAdmin.scrapNegotiation.bidNegotiationType
    ) {
      setBidNegotiationType(scrapAdmin.scrapNegotiation.bidNegotiationType);
    }
  }, [scrapAdmin]);

  useEffect(() => {
    if (
      selectedStatus !== "TO_DEAL" &&
      selectedStatus !== "AWAITING_BID" &&
      selectedStatus !== "IN_BID"
    ) {
      setShowContract(true);
    } else {
      setShowContract(false);
    }
  }, [selectedStatus, setValue]);

  useEffect(() => {
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0];
    setCurrentDate(formattedDate);
  }, []);

  useEffect(() => {
    if (scrapAdmin) {
      setTargetPrice(scrapAdmin?.scrapInfo?.targetPrice || "");
      setValue(
        "scrapNegotiation.targetPrice",
        scrapAdmin?.scrapInfo?.targetPrice || ""
      );
      setValue(
        "scrapInfo.targetPrice",
        scrapAdmin?.scrapInfo?.targetPrice || ""
      );
      setBidValue(scrapAdmin?.scrapBid?.bidValue || "");
      setValue("scrapBid.bidValue", scrapAdmin?.scrapBid?.bidValue || "");
    }
  }, [scrapAdmin, setValue]);

  const fetchEntityCountry = async () => {
    const data = await getAdrressByEntityId(id as string);
    const countryConfig = await getCountryConfigById(data.country);
    setCountryConfigEntity(countryConfig);
  };

  function formatCurrency(
    value: any,
    countryConfig: CountryConfigDTO | undefined
  ) {
    if (!countryConfig) return value;
    const formatter = new Intl.NumberFormat(countryConfig?.locale, {
      style: "currency",
      currency: countryConfig?.currency,
    });
    return formatter.format(value);
  }

  const fetchGenerator = async () => {
    await getScrapGeneratorInfo(id as string).then((generator) => {
      setGenerator(generator);
    });
  };

  const fetchContainers = async () => {
    try {
      if (countryConfigEntity && countryConfigEntity.country.length > 0) {
        const response = await getContainersByCountryName(
          countryConfigEntity.country[0]
        );
        setContainers(response);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const fetchAllPartnerRequirementsTotal = async () => {
    let total: string = "";
    if (countryConfigEntity?.id) {
      total = (
        await fetchPartnerRequirementsTotalByCountry(
          countryConfigEntity?.country[0]
        )
      ).length.toString();
    }
    return total;
  };

  useEffect(() => {
    fetchEntityCountry();
    fetchGenerator();
    fetchDealersPrivateBidList();
  }, []);

  useEffect(() => {
    if (generator) {
      setValue("scrapInfo.originName", generator?.tradingName);
    }
  }, [generator]);

  useEffect(() => {
    if (countryConfigEntity && countryConfigEntity.country.length > 0) {
      fetchContainers();
    }
  }, [countryConfigEntity]);

  const fetchData = async () => {
    if (dealersInvited) {
      const newDealers = await Promise.all(
        dealersInvited?.map(async (dealer) => ({
          id: dealer.id,
          dealerName: dealer?.legalName,
          inviteAccepted: false,
          proposedValue: " ",
          proposedOriginalValue: 0,
          attachment: " ",
          status: " ",
          region: dealer.region,
          inviteSended: false,
        }))
      );

      setTableData((prevData) => {
        const updatedData = prevData.filter((oldDealer) =>
          newDealers.some((newDealer) => newDealer.id === oldDealer.id)
        );

        const newItems = newDealers.filter(
          (newDealer) =>
            !updatedData.some((oldDealer) => oldDealer.id === newDealer.id)
        );

        return [...updatedData, ...newItems];
      });
    } else {
      setTableData([]);
    }
  };

  useEffect(() => {
    fetchData();
  }, [dealersInvited]);

  useEffect(() => {
    setValue("dealersInvitedTable.dealersInvitedList", tableData);
    setValue("scrapBid.dealersInvited", dealersInvited);
    if (scrapAdmin && id) {
      const updatedScrapAdmin = {
        ...scrapAdmin,
        dealersInvitedTable: {
          ...scrapAdmin.dealersInvitedTable,
          dealersInvitedList: tableData,
        },
        scrapBid: {
          ...scrapAdmin.scrapBid,
          dealersInvited: dealersInvited,
        },
        scrapInfo: {
          ...scrapAdmin.scrapInfo,
          containerType: selectedContainerType,
          containerNeeded: containerNeeded,
        },
      };

      const language: string =
        countryConfigEntity?.locale.split("-")[0] == "pt" ? "pt" : "en";

      addNewScrapAdmin(
        updatedScrapAdmin,
        id,
        true,
        selectedImages,
        removedFiles,
        language
      );
    }
  }, [tableData, id]);

  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);

  const cancelScrapForm = () => {
    cancelScrapAdmin(scrapAdmin).then(() => {
      setSelectedStatus(StatusEnum.CANCELED);
      setValue("scrapInfo.status", StatusEnum.CANCELED);
      setConfirmationModalOpen(false);
      setAlert({
        text: `${t("alert-canceled-success")}`,
        type: "success",
      });
      const delay = 1000;
      timer = setTimeout(() => {
        navigate(`/scrap-generators-details/${id}/scraps/${"r"}`);
      }, delay);
    });
  };
  function generateEmailContent(scrapAdmin: ScrapDTO): string {
    const inicioOperacao = scrapAdmin.scrapInfo.operationDate
      ? transformDateFormat(scrapAdmin.scrapInfo.operationDate.toString())
      : t("date_not_defined");

    const material = scrapAdmin.scrapInfo.scrapCategory.name || "";
    const transportadora = scrapAdmin.scrapInfo.carrier.name || "";
    const destinadoraFinal = scrapAdmin.scrapInfo.finalDestination?.name || "";
    const gerador = scrapAdmin.scrapInfo.originName || "";

    return `
    <p>${t("label-operation_start_scheduled")} ${inicioOperacao}.</p>
    <p><strong>${t("label-details")}:</strong></p>
    <ul>
      <li><strong>${t("label-generator")}:</strong> ${gerador}</li>
      <li><strong>${t("label-material")}:</strong> ${material}</li>
      <li><strong>${t("label-type-isCarrier")}:</strong> ${transportadora}</li>
      <li><strong>${t("label-type-isFinal")}:</strong> ${destinadoraFinal}</li>
    </ul>
    <p>${t("label-scheduling_instructions")}</p>
  `;
  }

  const onSubmit = async (scrapAdmin: ScrapDTO) => {
    setIsDisabled(true);
    if (!scrapAdmin.scrapInfo.containerType) {
      scrapAdmin.scrapInfo.containerType = "";
    }
    if (!scrapAdmin.scrapInfo.contractDealerName) {
      scrapAdmin.scrapInfo.contractDealerName = "";
    }
    if (operationRecipient == true) {
      const contractedDealer = await getContractedDealerObject();
      scrapAdmin.scrapInfo.finalDestination = contractedDealer;
    } else {
      updateCustomersByOperation(operationRecipientData);
    }
    if (operationCarrier == true) {
      const contractedDealer = await getContractedDealerObject();
      if (contractedDealer) {
        scrapAdmin.scrapInfo.carrier = contractedDealer;
      }
    }
    if (operationTemporaryStorage == true) {
      const contractedDealer = await getContractedDealerObject();
      if (contractedDealer) {
        scrapAdmin.scrapInfo.tempDealer = contractedDealer;
      }
    } else {
      updateCustomersByOperation(operationTemporaryStorageData);
    }
    if (saleableWaste) {
      scrapAdmin.scrapInfo.saleableWaste = true;
    }
    if (scrapAdmin.scrapInfo.status == undefined) {
      scrapAdmin.scrapInfo.status = StatusEnum.TO_DEAL;
      scrapAdmin.scrapInfo.creation = {
        createdAt: new Date(),
        createdBy: profile ?? "",
        createdUser: userDoc?.email ?? "",
      };
    }

    if (scrapAdmin.scrapInfo.containerNeeded == false) {
      scrapAdmin.scrapInfo.containerSize = "";
      scrapAdmin.scrapInfo.containerQuantity = "";
      scrapAdmin.scrapInfo.containerType = "";
    }

    if (
      (tableData && tableData.length === 0) ||
      scrapAdmin.dealersInvitedTable.dealersInvitedList.length === 0
    ) {
      await fetchData();
    }

    if (scrapId) {
      scrapAdmin.id = scrapId;
    }

    if (expiration && expiration.hasExpirationDate) {
      if (expiration.expirationDate?.length === 0) {
        return setAlert({
          text: `${t("alert-error-date-empty")}`,
          type: "error",
        });
      } else {
        scrapAdmin.scrapContract.expirationDocument = expiration;
      }
    }
    const days = valueRecurrent * unit;
    if (days > 1825) {
      setAlert({
        text: `${t("label-contract-time-expectation-error-be-longer")}`,
        type: "error",
      });
    } else {
      setValue("scrapInfo.contractPeriodDays", days);
      setValue("scrapInfo.contractPeriodDaysType", unit);
      if (id) {
        await addNewScrapAdmin(
          scrapAdmin,
          id,
          false,
          selectedImages,
          removedFiles
        ).then(async (scrapIdResponse) => {
          if (scrapAdmin.scrapInfo.operationDate) {
            const emailContent = generateEmailContent(scrapAdmin);

            const generatorId = scrapAdmin.scrapInfo.originId;
            let carrierId = "";
            if (
              scrapAdmin.scrapInfo.operationCarrierContractedCompany &&
              scrapAdmin.scrapInfo.carrier?.id
            ) {
              carrierId = scrapAdmin.scrapInfo.carrier?.id;
              setValue("scrapInfo.carrier.id", carrierId);
            } else {
              carrierId = "";
              setValue("scrapInfo.carrier.id", carrierId);
            }
            const finalDestinationId =
              scrapAdmin.scrapInfo.finalDestination?.id;

            if (generatorId) {
              await sendEmailGeneratorOrDealer(
                "Operação programada para Scrap",
                emailContent,
                generatorId
              );
            }

            if (carrierId && carrierId != "") {
              await sendEmailGeneratorOrDealer(
                "Operação programada para Scrap",
                emailContent,
                carrierId
              );
            }

            if (finalDestinationId) {
              await sendEmailGeneratorOrDealer(
                "Operação programada para Scrap",
                emailContent,
                finalDestinationId
              );
            }
          }

          if (scrapIdResponse) {
            data = { originId: id, generatorId: id };
            if (selectedFile && bidNegotiationType === "closed") {
              const response = await uploadCsvFile(
                selectedFile,
                "importdealersprivatebid",
                data,
                callFunction
              );
            }
            await new Promise((resolve) => setTimeout(resolve, 1000));
            navigate(
              `/scrap-generators-details/${id}/scraps-form/${scrapIdResponse}`
            );
          } else {
            closeForm().then(() => {
              navigate(
                `/scrap-generators-details/${id}/scraps-form/${scrapId}`
              );
            });
          }
          setAlert({
            text: scrapId
              ? t("alert-successfully-updated")
              : t("alert-successfully-registered"),
            type: "success",
          });
        });
      }
    }
    setIsDisabled(false);
  };

  async function closeForm() {
    fetchScrapData();
    await new Promise((resolve) => setTimeout(resolve, 1000));
    navigate(`/scrap-generators-details/${id}/scraps`);
  }

  const handleCategoryChange = (category: ScrapsCategoryInfoDTO) => {
    setSelectedCategoryDetails(category);
    setValue("scrapInfo.scrapCategory", category, { shouldValidate: true });
    setValue("scrapInfo.unity", category.unity.name);
    setSelectedUnity(t(`unityENUM.${category.unity.name}`));
  };

  const [containerNeeded, setContainerNeeded] = useState(true);
  const handleRadioContainerChange = (targetValue: boolean) => {
    setContainerNeeded(targetValue);
    setValue("scrapInfo.containerNeeded", targetValue);
  };

  const [saleableWaste, setSaleableWaste] = useState(true);

  const [operationRecipientData, setOperationRecipientData] = useState<any>();
  const [operationCarrierData, setOperationCarrierData] = useState<any>();
  const [operationTemporaryStorageData, setOperationTemporaryStorageData] =
    useState<any>();

  const [operationRecipient, setOperationRecipient] = useState(true);
  const [operationCarrier, setOperationCarrier] = useState(true);
  const [operationTemporaryStorage, setOperationTemporaryStorage] =
    useState(true);

  const finalDestination = watch("scrapInfo.finalDestination");

  const getContractedDealerObject = async () => {
    if (scrapAdmin?.scrapInfo.contractDealer) {
      const data = await getScrapDealerById(
        scrapAdmin?.scrapInfo.contractDealer
      );
      if (data) {
        const scrapContractedDealerInfo = {
          id: data.id,
          name: data.scrapDealerInfo.legalName,
          MTRcode: data?.scrapDealerInfo.mtrCode || "",
          nationalRegister: data.scrapDealerInfo.nationalRegister,
        };
        return scrapContractedDealerInfo;
      }
    }
    return null;
  };

  const handleRadioOperationRecipientChange = async (targetValue: boolean) => {
    if (targetValue) {
      const contractedDealer = await getContractedDealerObject();
      setValue("scrapInfo.finalDestination", contractedDealer);
    }
    setOperationRecipient(targetValue);
    setValue("scrapInfo.operationRecipientContractedCompany", targetValue);
  };

  const handleRadioOperationCarrierChange = async (targetValue: boolean) => {
    if (!targetValue) {
      setValue("scrapInfo.carrier", {
        id: "",
        MTRcode: "",
        name: "",
        nationalRegister: "",
      });
    }
    setOperationCarrier(targetValue);
    setValue("scrapInfo.operationCarrierContractedCompany", targetValue);
  };

  const handleRadioOperationTempStorageChange = async (
    targetValue: boolean
  ) => {
    if (!targetValue) {
      setValue("scrapInfo.tempDealer", {
        id: "",
        MTRcode: "",
        name: "",
        nationalRegister: "",
      });
    }
    setOperationTemporaryStorage(targetValue);
    setValue("scrapInfo.operationTempStorageContractedCompany", targetValue);
  };

  const handleRadioContainerChangeSale = (targetValue: boolean) => {
    setSaleableWaste(targetValue);
    setValue("scrapInfo.saleableWaste", targetValue);
  };

  const [unit, setUnit] = useState(365);
  const [valueRecurrent, setValueRecurrent] = useState(1);

  useEffect(() => {
    const contractPeriodDays = valueRecurrent * unit;
    setValue("scrapInfo.contractPeriodDays", contractPeriodDays);
    setValue("scrapInfo.contractPeriodDaysType", unit);
    if (scrapAdmin?.scrapContract.contractDate) {
      handleCalculateValidateDate(scrapAdmin?.scrapContract.contractDate);
    }
  }, [valueRecurrent, unit]);

  const contractPeriodOptions = [
    { display: `${t("years")}`, value: 365 },
    { display: `${t("months")}`, value: 30 },
  ];

  const [bidNegotiationType, setBidNegotiationType] = useState<string>("open");
  const [responsibleShipping, setResponsibleShipping] = useState<string>("");

  const [today, setToday] = useState("");

  const [expiration, setExpiration] = useState<ExpirationDTO>({
    originId: "",
    docName: "Contrato",
    expirationDate: "",
    warningPeriod: 60,
    solved: false,
    hasExpirationDate: false,
    origin: "",
  });

  const defaultAddress: AddressInfoDTO = {
    address: "",
    state: "",
    country: "",
    countryName: "",
    city: "",
    postalCode: "",
    postalCodeLabel: "",
  };

  const [address, setAddress] = useState<AddressInfoDTO>(
    scrapAdmin?.scrapInfo?.operationAddress || defaultAddress
  );

  const handleDataChange = (key: string, value: any) => {
    setExpiration((contractExpirationDate: ExpirationDTO) => ({
      ...contractExpirationDate,
      [key]: value,
    }));
  };

  useEffect(() => {
    if (expiration) {
      setValue("scrapContract.expirationDocument", expiration);
    }
  }, [expiration]);

  const getIconName = (rowItem: any) => {
    if (rowItem.inviteAccepted) return "checkmark-frame";
    if (rowItem.inviteSended) return "mail-forward";
    return "mail";
  };

  const [containerQuantityMaskedValue, setContainerQuantityMaskedValue] =
    useState("");
  const [quantityMaskedValue, setQuantityMaskedValue] = useState("");

  const handleInputChangeContainerQuantity = (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const { value } = event.target;
    const masked = applyDecimalMask(value);
    setValue(`scrapInfo.containers.${index}.containerQuantity`, masked);
  };


  const handleInputChangeQuantity = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value } = event.target;
    const masked = applyDecimalMask(value);
    setQuantityMaskedValue(masked);
  };

  useEffect(() => {
    setValue("scrapInfo.quantity", containerQuantityMaskedValue);
  }, []);

  useEffect(() => {
    setValue("scrapInfo.containerQuantity", quantityMaskedValue);
  }, []);

  const handleSaveAddress = (newAddress: any) => {
    setAddress(newAddress);
    setValue("scrapInfo.operationAddress", newAddress);
  };

  const handleChangePicker = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    setBidNegotiationType(value);
    setValue("scrapNegotiation.bidNegotiationType", value);
    if (scrapId) {
      updateOnlyFieldOfForm(
        scrapId,
        COLLECTIONS.SCRAP_BY_GENERATOR_NEGOTIATION,
        "bidNegotiationType",
        value
      ).then(() => {
        fetchDealersPrivateBidList();
      });
    }
  };

  const handleSelectChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const contractedDealerId = e.target.value;
    if (!contractedDealerId) return;

    const generatorId = scrapAdmin?.scrapInfo.originId;
    updateFieldWithArrayUnion(
      COLLECTIONS.SCRAP_DEALERS,
      contractedDealerId,
      "customers",
      generatorId
    );
  };

  const updateCustomersByOperation = (data: ScrapDealerDTO) => {
    if (data) {
      const dealerId = data?.id;
      const generatorId = scrapAdmin?.scrapInfo.originId;

      updateFieldWithArrayUnion(
        COLLECTIONS.SCRAP_DEALERS,
        dealerId,
        "customers",
        generatorId
      );
    }
  };

  const handleCalculateValidateDate = (e: string) => {
    if (valueRecurrent && unit && expiration) {
      const expirationDateEstimate = addDaysAndTransformDateStringToDate(
        e,
        valueRecurrent * unit
      );
      if (scrapAdmin?.scrapInfo.expirationDocument.expirationDate == "") {
        setExpiration({
          ...expiration,
          expirationDate: formatDateToStringYearFirst(expirationDateEstimate),
        });
      }
    }
  };

  const handleChangeResponsibleShipping = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    const value = e.target.value;
    setValue("scrapInfo.responsibleShipping", value);
    setResponsibleShipping(value);
  };

  useEffect(() => {
    if (id && !scrapId) {
      getAdrressByEntityId(id).then((data) => {
        setAddress(data as AddressInfoDTO);
        setValue("scrapInfo.operationAddress", data);
      });
    }
  }, [id]);

  useEffect(() => {
    const todayDate = new Date().toISOString().split("T")[0];
    setToday(todayDate);
  }, []);

  useEffect(() => {
    if (scrapAdmin) {
      setValue("scrapInfo.scrapCategory", scrapAdmin?.scrapInfo?.scrapCategory);
    }
  }, [scrapAdmin, setValue]);

  const getAttachmentText = (attachments: string[]) => {
    let attachmentString: string = "";

    if (attachments.length === 1 && attachments[0].trim() === "") {
      attachments = [];
    }

    if (attachments.length > 0) {
      const attachmentCount = attachments.length;
      attachmentString = `${t("label-attachment")} (${attachmentCount})`;
    } else {
      attachmentString = "-";
    }

    return attachmentString;
  };

  const fetchDealersPrivateBidList = async () => {
    if (scrapId) {
      const privateBidList = await getPrivateBidList(scrapId);
      setPrivateBidList(privateBidList);
    }
  };

  if (enabledUsers.includes(profile || "public")) {
    return (
      <div className="page-centered">
        {confirmationModalOpen && (
          <div className="modal-background">
            <GenericConfirmationModal
              onClose={() => setConfirmationModalOpen(false)}
              onConfirm={() => cancelScrapForm()}
            >
              <p>{t("cancel-confirmation-message")}</p>
            </GenericConfirmationModal>
          </div>
        )}
        {editTableModalOpen && editTableItem && (
          <div className="modal-background">
            <ScrapDealersInvitedModalForm
              countryConfigEntity={countryConfigEntity}
              tableData={editTableItem}
              onClose={handleCloseTableModal}
              id={scrapId || ""}
              scrapData={scrapAdmin ? scrapAdmin : undefined}
            />
          </div>
        )}
        {sendMailModal && (
          <div className="modal-background">
            <ScrapDealersSendMailModal
              onClose={() => {
                setSendMailModal(false);
                setIdsToSend([]);
                const delay = 1500;
                timer = setTimeout(() => {
                  fetchScrapData();
                }, delay);
              }}
              multIDS={idsToSend}
              id={scrapId || ""}
            />
          </div>
        )}
        {isModalOpen && (
          <UploadCsvModal
            onClose={handleCloseModal}
            passFileToParent={scrapId ? false : true}
            onFileSelect={(file) => setSelectedFile(file)}
            data={data}
            apiData={"importdealersprivatebid"}
            templateUrl={`https://firebasestorage.googleapis.com/v0/b/rbprj-100132.appspot.com/o/templates%2F${"importdealersprivatebid"}.csv?alt=media`}
          />
        )}
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="form-fields">
            {scrapAdmin?.scrapInfo.status == StatusEnum.DISAPPROVED && (
              <div
                className="info-section"
                style={{ borderLeft: "5px solid var(--bosch-error-red)" }}
              >
                <div className="flex-row align-center" style={{ gap: 5 }}>
                  <SparkIcon
                    icName="alert-warning"
                    noPadding
                    className="margin-topbottom-1"
                  />
                  <h3 style={{ margin: 0 }}>{t("label-reproved-proposal")}</h3>
                </div>
                <div className="flex-column">
                  <label htmlFor="reproval-reason" style={{ marginBottom: 10 }}>
                    {t("label-reason")}
                  </label>
                  <textarea
                    disabled
                    value={scrapAdmin?.scrapInfo.reasonDisapproval}
                    style={{ maxWidth: "98.5%", minWidth: "98.5%" }}
                    placeholder={t("label-reason")}
                    id="reproval-reason"
                  />
                </div>
              </div>
            )}
            <CollapsibleSection title={t("material-about-material")}>
              <div className="flex-column">
                <div className="flex-row radio-types">
                  <div className="flex-row">
                    <input
                      type="radio"
                      id="saleDisposal"
                      value="true"
                      onChange={(e) => handleRadioContainerChangeSale(true)}
                      checked={saleableWaste === true}
                    />
                    <label
                      style={{ margin: "10px 0px" }}
                      htmlFor="saleDisposal"
                    >
                      {t("label-saleDisposal")}
                    </label>
                  </div>
                  <div className="flex-row">
                    <input
                      type="radio"
                      id="non-saleDisposal"
                      value="false"
                      onChange={() => handleRadioContainerChangeSale(false)}
                      checked={saleableWaste === false}
                    />
                    <label
                      style={{ margin: "10px" }}
                      htmlFor="non-saleDisposal"
                    >
                      {t("label-non-saleDisposal")}
                    </label>
                  </div>
                  {errors.scrapInfo?.saleableWaste === null &&
                    scrapAdmin?.scrapInfo?.saleableWaste && (
                      <span>{t("error-input-required")}</span>
                    )}
                </div>
              </div>

              <div className="flex-column margin-topbottom-1">
                <ScrapCategoryInputAutocomplete
                  label={`${t("label-scrap-category")}*`}
                  placeholder={t("label-scrap-category")}
                  onChange={handleCategoryChange}
                  initialValue={
                    scrapAdmin &&
                    scrapAdmin.scrapInfo &&
                    scrapAdmin.scrapInfo.scrapCategory
                  }
                />
                {!selectedCategoryDetails && isSubmitted && (
                  <span>{t("error-input-required")}</span>
                )}
                {selectedCategoryDetails && (
                  <div className="flex-row info-section">
                    <img
                      style={{
                        height: "6rem",
                        width: "8rem",
                        overflow: "hidden",
                        marginRight: "1rem",
                      }}
                      src={
                        selectedCategoryDetails?.images &&
                        selectedCategoryDetails?.images.length > 0
                          ? selectedCategoryDetails?.images[
                          selectedCategoryDetails?.images.length - 1
                          ]
                          : genericImage
                      }
                      alt="material image"
                    />
                    <div style={{ width: "100%" }} className="flex-column">
                      <h2>{selectedCategoryDetails.name}</h2>
                      <div className="custom-line-hr"></div>
                      <div className="flex-row justify-between card-scrap-basic-info">
                        <div
                          className="flex-column"
                          style={{ gap: "10px", maxWidth: "80%" }}
                        >
                          <p style={{ wordWrap: "break-word" }}>
                            {t("label-material-class")}:{" "}
                            <strong>
                              {selectedCategoryDetails.materialClass.name ||
                                "-"}
                            </strong>
                          </p>
                        </div>
                        <div
                          className="flex-column"
                          style={{ gap: "10px", maxWidth: "80%" }}
                        >
                          <p style={{ wordWrap: "break-word" }}>
                            {t("label-physical-state")}:{" "}
                            <strong>
                              {" "}
                              {t(
                                `physicalStateENUM.${selectedCategoryDetails.phisycalState.name}`
                              )}
                            </strong>
                          </p>
                        </div>{" "}
                        <div
                          className="flex-column"
                          style={{ gap: "10px", maxWidth: "80%" }}
                        >
                          <p style={{ wordWrap: "break-word" }}>
                            {t("label-unity")}:{" "}
                            <strong>
                              {selectedCategoryDetails.unity.name || "-"}
                            </strong>
                          </p>
                        </div>
                        {" "}
                        <div
                          className="flex-column"
                          style={{ gap: "10px", maxWidth: "80%" }}
                        >
                          <p style={{ wordWrap: "break-word" }}>
                            {t("label-ibama-code")}:{" "}
                            <strong>
                              {selectedCategoryDetails.ibamaCode || "-"}
                            </strong>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="flex-row double-fields">
                <div className="flex-column margin-topbottom-1">
                  <label htmlFor="material-code-NCM">
                    {t("material-code-NCM")}
                  </label>
                  <div
                    className="flex-row double-fields"
                    style={{
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <div className="flex-column">
                      <input
                        type="text"
                        id="material-code-NCM"
                        {...register("scrapInfo.codeNCM", {
                          required: false,
                        })}
                      />
                    </div>
                    <div className="flex-column">
                      <a
                        href="https://portalunico.siscomex.gov.br/classif/#/nomenclatura/tabela?perfil=publico"
                        target="_blank"
                      >
                        Consulte a lista do NCM aqui!
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex-column margin-topbottom-1">
                <label htmlFor="material-special-description">
                  {t("material-special-description")}
                </label>
                <input
                  placeholder={t("material-placeholder-special-description")}
                  type="text"
                  id="material-special-description"
                  {...register("scrapInfo.specialDescription", {
                    required: false,
                  })}
                />
              </div>

              <div className="flex-column">
                <UploadFileOrImage
                  onlyImages={true}
                  onSave={(itens, removedFiles) =>
                    handleImageChange(itens, removedFiles)
                  }
                  initialSavedFiles={scrapAdmin?.scrapInfo?.images || []}
                  fieldLabel={t("material-add-photos")}
                />
              </div>
            </CollapsibleSection>

            <CollapsibleSection title={t("material-about-operation")}>
              <div className="flex-column margin-topbottom-1">
                <div className="flex-column margin-topbottom-1">
                  <label htmlFor="material-dealers-invited"></label>
                  <MTRTreatmentInputAutocomplete
                    label={t("treatment")}
                    placeholder={t("")}
                    control={control}
                    name="scrapInfo.treatmentMTRCode"
                    errors={errors}
                    onChange={(treatmentMTRCode) => {
                      if (treatmentMTRCode) {
                        setValue(
                          "scrapInfo.treatmentMTRCode",
                          treatmentMTRCode
                        );
                      }
                    }}
                    initialValue={
                      scrapAdmin &&
                      scrapAdmin.scrapInfo &&
                      scrapAdmin.scrapInfo.treatmentMTRCode
                    }
                    isDisabled={false}
                  />
                </div>
                <label htmlFor="material-quantity">
                  {`${t("material-quantity")}*`}
                </label>
                <div className="flex-row double-fields">
                  <div className="flex-column">
                    <input
                      placeholder={t("label-quantity")}
                      type="text"
                      value={quantityMaskedValue}
                      id="label-quantity"
                      {...register("scrapInfo.quantity", {
                        required: true,
                      })}
                      onChange={handleInputChangeQuantity}
                    />
                    {errors.scrapInfo?.quantity && isSubmitted && (
                      <span>{t("error-input-required")}</span>
                    )}
                  </div>

                  <div className="flex-column">
                    <select
                      disabled
                      id="material-quantity-unity"
                      {...register("scrapInfo.unity", { required: true })}
                      onChange={handleUnityChange}
                    >
                      <option value=""></option>
                      {Object.entries(unityENUM).map(([key, value]) => (
                        <option key={key} value={key}>
                          {t(`unityENUM.${value}`)}
                        </option>
                      ))}
                    </select>
                    {errors.scrapInfo?.unity && isSubmitted && (
                      <span>{t("error-input-required")}</span>
                    )}
                  </div>
                  <div className="flex-column">
                    <select
                      id="material-quantity-period"
                      {...register("scrapInfo.period", { required: true })}
                      onChange={(e) => {
                        setValue("scrapInfo.period", e.target.value);
                        setCurrentPeriod(e.target.value);
                        if (e.target.value === "SINGLE_SALE") {
                          setValue("scrapInfo.pickUpFrequency", e.target.value);
                        }
                      }}
                    >
                      <option value=""></option>
                      {Object.entries(periodENUM).map(([key, value]) => (
                        <option key={key} value={key}>
                          {t(`periodENUM.${value}`)}
                        </option>
                      ))}
                      <option value="SINGLE_SALE">
                        {t("label-single-sale")}
                      </option>
                    </select>
                    {errors.scrapInfo?.period && isSubmitted && (
                      <span>{t("error-input-required")}</span>
                    )}
                  </div>
                </div>
              </div>

              <div className="double-fields">
                <div className="flex-column">
                  <label htmlFor="material-pick-up-frequency">
                    {`${t("material-pick-up-frequency")}*`}
                  </label>

                  {currentPeriod !== "SINGLE_SALE" ? (
                    <select
                      id="material-pick-up-frequency"
                      {...register("scrapInfo.pickUpFrequency", {
                        required: true,
                      })}
                    >
                      <option value=""></option>
                      {Object.entries(periodENUM).map(([key, value]) => (
                        <option key={key} value={key}>
                          {t(`periodENUM.${value}`)}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <select disabled>
                      <option value="SINGLE_SALE">
                        {t("label-single-sale")}
                      </option>
                    </select>
                  )}

                  {errors.scrapInfo?.pickUpFrequency && (
                    <span>{t("error-input-required")}</span>
                  )}
                </div>

                <div className="flex-column">
                  <label htmlFor="responsible-shipping">
                    {t("label-responsible-shipping")}
                  </label>
                  <select onChange={handleChangeResponsibleShipping}>
                    <option value={""}></option>
                    <option
                      selected={
                        scrapAdmin?.scrapInfo?.responsibleShipping ===
                        "generator"
                      }
                      value={"generator"}
                    >
                      {t("label-generator")}
                    </option>
                    <option
                      selected={
                        scrapAdmin?.scrapInfo?.responsibleShipping === "buyer"
                      }
                      value={"buyer"}
                    >
                      {t("label-buyer")}
                    </option>
                  </select>
                  {responsibleShipping === "" && isSubmitted && (
                    <span>{t("error-input-required")}</span>
                  )}
                </div>
              </div>

              <AddressSectionFields
                initialValues={address}
                onSave={handleSaveAddress}
              ></AddressSectionFields>

              <div className="flex-column">
                <h4>{t("material-does-container")}</h4>
                <div className="flex-row radio-types">
                  <div className="flex-row">
                    <label
                      style={{ margin: "10px 0px" }}
                      htmlFor="material-container"
                    >
                      <input
                        type="radio"
                        id="material-container"
                        value="true"
                        onChange={(e) => handleRadioContainerChange(true)}
                        checked={containerNeeded === true}
                      />
                      {t("label-need")}
                    </label>
                  </div>
                  <div className="flex-row">
                    <label style={{ margin: "10px" }} htmlFor="isBranch">
                      <input
                        type="radio"
                        id="isBranch"
                        value="false"
                        onChange={() => handleRadioContainerChange(false)}
                        checked={containerNeeded === false}
                      />
                      {t("label-non-need")}
                    </label>
                  </div>
                  {errors.scrapInfo?.containerNeeded === null &&
                    scrapAdmin?.scrapInfo?.containerNeeded && (
                      <span>{t("error-input-required")}</span>
                    )}
                </div>
              </div>

              {containerNeeded === true && countryConfigEntity && (
                <div className="flex-column">
                  {fields.map((item, index) => (
                    <div className="flex-row double-fields margin-topbottom-1" key={item.id}>


                      <div className="flex-column" style={{ justifyContent: "center" }}>
                        <ScrapStorageInputAutocomplete
                          countryConfigEntity={countryConfigEntity}
                          label={t("material-container-type")}
                          onChange={(value) => {
                            setValue(`scrapInfo.containers.${index}.containerType`, value);
                          }}
                          placeholder={t("material-container-type")}
                          initialValue={scrapAdmin?.scrapInfo?.containers?.[index]?.containerType}
                        />
                        {errors.scrapInfo?.containers?.[index]?.containerType && (
                          <span>{t("error-input-required")}</span>
                        )}
                      </div>


                      <div className="flex-column">
                        <label htmlFor={`scrapInfo.containers[${index}].containerSize`}>
                          {t("material-container-size")}
                        </label>
                        <input
                          placeholder={t("placeholder.generalEmpty")}
                          type="text"
                          id={`scrapInfo.containers[${index}].containerSize`}
                          {...register(`scrapInfo.containers.${index}.containerSize`, {
                            required: false,
                          })}
                        />
                        {errors.scrapInfo?.containers?.[index]?.containerSize && (
                          <span>{t("error-input-required")}</span>
                        )}
                      </div>


                      <div className="flex-column">
                        <label htmlFor={`scrapInfo.containers[${index}].containerQuantity`}>
                          {`${t("material-container-quantity")}*`}
                        </label>
                        <input
                          type="text"
                          id={`scrapInfo.containers[${index}].containerQuantity`}
                          {...register(`scrapInfo.containers.${index}.containerQuantity`, {
                            required: true,
                          })}
                          value={watch(`scrapInfo.containers.${index}.containerQuantity`)}
                          onChange={(e) => handleInputChangeContainerQuantity(e, index)}
                        />
                        {errors.scrapInfo?.containers?.[index]?.containerQuantity && (
                          <span>{t("error-input-required")}</span>
                        )}
                      </div>



                      <button
                        type="button"
                        style={{ margin: 0 }}
                        className="neutral-white"
                        disabled={index == 0}
                        onClick={() => remove(index)}
                      >
                        <SparkIcon icName="delete" noPadding></SparkIcon>
                      </button>
                    </div>
                  ))}


                  <button
                    type="button"
                    style={{ margin: "5px 0px 5px", width: "100%" }}
                    onClick={() => append({ containerType: "", containerSize: "", containerQuantity: "" })}
                  >
                    <SparkIcon icName="add"></SparkIcon>
                  </button>
                </div>
              )}

              <div className="form-fields flex-column">
                <div className="flex-column">
                  <label htmlFor="observationsStorage">
                    {t("label-observations-storage")}
                  </label>
                  <textarea
                    id="observationsStorage"
                    {...register("scrapInfo.observationsStorage")}
                  />
                </div>
              </div>

              {currentPeriod !== "SINGLE_SALE" && (
                <div style={{ marginTop: "1rem" }}>
                  <h4>{t("label-contract-time-expectation")}</h4>
                  <div className="double-fields">
                    <div
                      className="double-fields"
                      style={{ marginTop: "1rem" }}
                    >
                      <div className="flex-row" style={{ flex: 1 }}>
                        <button
                          type="button"
                          style={{ margin: 0 }}
                          onClick={() =>
                            setValueRecurrent(
                              valueRecurrent <= 1 ? 1 : valueRecurrent - 1
                            )
                          }
                          className="number-input-button"
                        >
                          -
                        </button>
                        <input
                          className="expiration-input-qtt-days"
                          value={valueRecurrent}
                          onChange={(e) =>
                            setValueRecurrent(parseInt(e.target.value))
                          }
                          type="number"
                        />
                        <button
                          type="button"
                          style={{ margin: 0 }}
                          onClick={() => setValueRecurrent(valueRecurrent + 1)}
                          className="number-input-button"
                        >
                          +
                        </button>
                      </div>
                      <div className="flex-column" style={{ flex: 1 }}>
                        <select
                          value={unit}
                          onChange={(e) => {
                            setUnit(parseInt(e.target.value));
                          }}
                          style={{ width: "100%" }}
                        >
                          {contractPeriodOptions.map((obj, index) => (
                            <option key={index} value={obj.value}>
                              {obj.display}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </CollapsibleSection>

            <CollapsibleSection title={t("material-about-negotiation")}>
              <div className="double-fields">
                <div className="flex-column">
                  <label htmlFor="material-price-expectancy">
                    {t("material-price-expectancy")}
                    <span
                      style={{ margin: 0, marginLeft: 5, color: "#9e9e9e" }}
                    >
                      {`(${countryConfigEntity?.currencyName}/${selectedUnity || "unity"
                        })`}
                    </span>
                  </label>
                  <CurrencyInput
                    currency={countryConfigEntity?.currency}
                    locale={countryConfigEntity?.locale}
                    defaultValue={targetPrice}
                    onChangeValue={(event, originalValue, maskedValue) => {
                      setTargetPrice(maskedValue.toString());
                      setValue(
                        "scrapNegotiation.targetPrice",
                        maskedValue.toString(),
                        {
                          shouldValidate: true,
                        }
                      );
                    }}
                    InputElement={
                      <input
                        placeholder={t("material-price-expectancy")}
                        type="text"
                        id="targetPrice"
                        {...register("scrapNegotiation.targetPrice", {
                          required: false,
                        })}
                      />
                    }
                  />
                  {errors.scrapNegotiation?.targetPrice && (
                    <span>{t("error-input-required")}</span>
                  )}
                </div>
              </div>

              <div style={{ marginTop: "1rem" }} className="flex-column">
                <div className="flex-column">
                  <label htmlFor="material-sales-date-final">
                    {`${t("material-sales-date")}*`}
                  </label>
                  <input
                    type="date"
                    min={getMinDate()}
                    id="material-sales-date-final"
                    {...register("scrapNegotiation.salesDate", {
                      required: true,
                    })}
                  />
                  {errors.scrapNegotiation?.salesDate && (
                    <span>{t("error-input-required")}</span>
                  )}
                </div>
              </div>

              <div className="double-fields margin-topbottom-1">
                <div className="flex-column">
                  <label htmlFor="material-negotiation-type">
                    {t("material-negotiation-type")}
                  </label>
                  <select
                    value={bidNegotiationType}
                    onChange={handleChangePicker}
                  >
                    <option value={"open"}>{t("label-open-bid")}</option>
                    <option value={"closed"}>{t("label-closed-bid")}</option>
                  </select>
                </div>
                {bidNegotiationType && bidNegotiationType === "closed" && (
                  <div className="flex-row align-end">
                    <button
                      id="material-add-prefered-suppliers"
                      type="button"
                      style={{ margin: 0 }}
                      title={t("label-upload-csv")}
                      onClick={handleOpenModal}
                      className="neutral-white white-with-icon button ml-10"
                    >
                      <img src={uploadIcon} alt={t("label-upload-csv")} />
                    </button>

                    {selectedFile &&
                      bidNegotiationType === "closed" &&
                      !scrapId ? (
                      <label
                        className="a-link-style"
                        htmlFor="material-add-prefered-suppliers"
                        style={{ padding: "0.2rem" }}
                      >
                        {t("label-attached-file")}
                      </label>
                    ) : (
                      <label htmlFor="material-add-prefered-suppliers">
                        {t("material-add-prefered-suppliers")}
                      </label>
                    )}
                  </div>
                )}
              </div>
              {privateBidList && bidNegotiationType === "closed" && scrapId && (
                <div>
                  <SparkTable>
                    <SparkTableHead
                      className="flex-row"
                      style={{ alignItens: "center" }}
                    >
                      <SparkTableRow>
                        {privateBidTableHeader?.map((header, index) => (
                          <SparkTableCell
                            style={{
                              alignItens: "center",
                              display: "flex",
                              flexDirection: "row",
                            }}
                            key={index}
                          >
                            <strong>{header.toUpperCase()}</strong>
                          </SparkTableCell>
                        ))}
                      </SparkTableRow>
                    </SparkTableHead>

                    <SparkTableBody>
                      {privateBidList?.map(
                        (rowItem: PrivateBidDTO, rowIndex: any) => (
                          <SparkTableRow key={rowIndex}>
                            <SparkTableCell>
                              {rowItem.nomeContato}
                            </SparkTableCell>
                            <SparkTableCell>{rowItem.email}</SparkTableCell>
                            <SparkTableCell>{rowItem.telefone}</SparkTableCell>
                          </SparkTableRow>
                        )
                      )}
                    </SparkTableBody>
                  </SparkTable>
                </div>
              )}
            </CollapsibleSection>
            {scrapId && (
              <CollapsibleSection title={t("material-about-bid")}>
                <div
                  className="flex-row justify-center align-center pill-tag"
                  style={{ gap: 5, fontWeight: 400 }}
                >
                  <SparkIcon icName="cloud-upload" noPadding></SparkIcon>
                  <p>{t("label-update-dynamic-section")}</p>
                </div>

                {scrapAdmin?.scrapInfo.status !== undefined && (
                  <div
                    className="flex-column margin-topbottom-1"
                    style={{ gap: 10 }}
                  >
                    <p>{t("material-bid-status")}</p>
                    <h3> {t(`statusEnum.${scrapAdmin?.scrapInfo.status}`)}</h3>
                  </div>
                )}

                <div className="flex-row margin-topbottom-1">
                  <div className="flex-column" style={{ gap: 10 }}>
                    <p>{t("contract-total-price-preview")}</p>
                    <h3>
                      {!isNaN(
                        formatCurrency(
                          scrapAdmin?.scrapInfo.contractTotalPricePreview,
                          countryConfigEntity
                        )
                      )
                        ? formatCurrency(
                            scrapAdmin?.scrapInfo.contractTotalPricePreview,
                            countryConfigEntity
                          )
                        : " - "}
                    </h3>
                  </div>
                  <div className="flex-column right-column" style={{ gap: 10 }}>
                    <p>
                      {t("contract-total-quantity-preview").replace(
                        "{{VARIABLE}}",
                        selectedUnity
                      )}
                    </p>
                    <h3>
                      {scrapAdmin?.scrapInfo?.contractTotalQuantityPreview
                        ?.toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                    </h3>
                  </div>
                </div>

                <div className="double-fields">
                  <div className="flex-column margin-topbottom-1">
                    <label htmlFor="material-bid-type">
                      {t("material-bid-type")}
                    </label>
                    <select
                      id="material-bid-type"
                      {...register("scrapBid.bidType", { required: false })}
                      onChange={(e) => {
                        if (scrapId) {
                          updateOnlyFieldOfForm(
                            scrapId,
                            COLLECTIONS.SCRAP_BY_GENERATOR_BID,
                            "bidType",
                            e.target.value
                          );
                        }
                      }}
                    >
                      <option value=""></option>
                      {Object.values(MaterialBidTypeEnum).map((type) => (
                        <option key={type} value={type}>
                          {t(`bidTypeEnum.${type}`)}
                        </option>
                      ))}
                    </select>
                    {errors.scrapBid?.bidType && (
                      <span>{t("error-input-required")}</span>
                    )}
                  </div>

                  <div className="flex-column margin-topbottom-1">
                    <label htmlFor="material-bid-date">
                      {t("material-bid-date")}
                    </label>
                    <input
                      placeholder={t("material-bid-date")}
                      type="date"
                      min={!scrapId ? today : undefined}
                      id="material-bid-date"
                      {...register("scrapBid.bidDate", {
                        required: false,
                      })}
                      onChange={(e) => {
                        if (scrapId) {
                          updateOnlyFieldOfForm(
                            scrapId,
                            COLLECTIONS.SCRAP_BY_GENERATOR_BID,
                            "bidDate",
                            e.target.value
                          );
                        }
                      }}
                    />
                    {errors.scrapBid?.bidDate && (
                      <span>{t("error-input-required")}</span>
                    )}
                  </div>

                  <div className="flex-column margin-topbottom-1">
                    <label htmlFor="material-bid-value">
                      {t("material-bid-value")}
                      <span
                        style={{ margin: 0, marginLeft: 5, color: "#9e9e9e" }}
                      >
                        {`(${countryConfigEntity?.currencyName}/${
                          selectedUnity || "unity"
                        })`}
                      </span>
                    </label>
                    <CurrencyInput
                      currency={countryConfigEntity?.currency}
                      locale={countryConfigEntity?.locale}
                      defaultValue={scrapAdmin?.scrapBid?.bidValue}
                      onChangeValue={(event, originalValue, maskedValue) => {
                        setBidValue(maskedValue.toString());
                        setValue("scrapBid.bidValue", maskedValue.toString(), {
                          shouldValidate: true,
                        });
                        if (scrapId) {
                          updateOnlyFieldOfForm(
                            scrapId,
                            COLLECTIONS.SCRAP_BY_GENERATOR_BID,
                            "bidValue",
                            maskedValue
                          );
                        }
                      }}
                      InputElement={
                        <input
                          placeholder={t("material-bid-value")}
                          type="text"
                          id="material-bid-value"
                          {...register("scrapBid.bidValue", {
                            required: false,
                          })}
                        />
                      }
                    />
                    {errors.scrapBid?.bidValue && (
                      <span>{t("error-input-required")}</span>
                    )}
                  </div>
                </div>

                <div className="form-fields flex-column">
                  <div className="flex-column">
                    <label htmlFor="requiriments-approval-bid">
                      {t("label-requiriments-approval-bid")}
                    </label>
                    <textarea
                      placeholder={t("placeholder.requirimentsApprovalBid")}
                      id="requiriments-approval-bid"
                      {...register("scrapBid.requirimentsApprovalBid")}
                      onChange={(e) => {
                        if (scrapId) {
                          updateOnlyFieldOfForm(
                            scrapId,
                            COLLECTIONS.SCRAP_BY_GENERATOR_BID,
                            "requirimentsApprovalBid",
                            e.target.value
                          );
                        }
                      }}
                    />
                  </div>
                </div>

                <div className="flex-column margin-topbottom-1">
                  <label htmlFor="material-dealers-invited">
                    {t("material-dealers-invited")}
                  </label>
                  <ScrapDealerInputAutocomplete
                    onChange={(data) => {
                      setValue("scrapBid.dealersInvited", data);
                      setDealersInvited(data);
                    }}
                    placeholder={t("material-dealers-invited")}
                    defaultValue={scrapAdmin?.scrapBid?.dealersInvited}
                  ></ScrapDealerInputAutocomplete>
                  {errors.scrapBid?.dealersInvited && (
                    <span>{t("error-input-required")}</span>
                  )}
                </div>

                {tableData.length !== 0 && scrapId && (
                  <div className="flex-column info-section">
                    <div
                      className="flex-row align-center justify-between"
                      style={{ height: "50px" }}
                    >
                      <h3 style={{ margin: 0 }}>
                        {t("material-dealers-invited")}
                      </h3>
                      <ImportExportCsv
                        exportApi="exportscrapbygeneratorinvitedtablecsv"
                        importApi="importscrapbygeneratorinvitedtablecsv"
                        data={data}
                        onClose={handleCloseModal}
                      />
                    </div>
                    <SparkTable>
                      <SparkTableHead
                        className="flex-row"
                        style={{ alignItens: "center" }}
                      >
                        <SparkTableRow>
                          {tableHeader?.map((header, index) => (
                            <SparkTableCell
                              style={{
                                alignItens: "center",
                                justifyContent:
                                  index != 1 && index != 2 ? "center" : "start",
                                display: "flex",
                                flexDirection: "row",
                                margin: "1rem 0",
                                flex: index != 0 ? "1" : "0.3",
                              }}
                              key={index}
                            >
                              <strong>{header.toUpperCase()}</strong>
                            </SparkTableCell>
                          ))}
                        </SparkTableRow>
                      </SparkTableHead>

                      <SparkTableBody>
                        {tableData?.map((rowItem: any, rowIndex: any) => (
                          <SparkTableRow
                            key={rowIndex}
                            onClick={(e) => handleOpenTableModal(rowItem)}
                          >
                            <SparkTableCell
                              style={{ flex: "0.4", justifyContent: "center" }}
                            >
                              <input
                                type="checkbox"
                                checked={idsToSend.some(
                                  (item) => item.id === rowItem.id
                                )}
                                onChange={(e) => { }}
                                onClick={(e: any) =>
                                  handlerMails(e, {
                                    id: rowItem.id,
                                    name: rowItem.dealerName,
                                  })
                                }
                              />
                            </SparkTableCell>

                            <SparkTableCell style={{ justifyContent: "start" }}>
                              {rowItem.dealerName}
                            </SparkTableCell>
                            <SparkTableCell style={{ justifyContent: "start" }}>
                              {rowItem.region}
                            </SparkTableCell>

                            <SparkTableCell
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <SparkIcon
                                className="icon-flag"
                                pallete="tertiary"
                                no-padding={true}
                                icName={getIconName(rowItem)}
                              />
                              <p style={{ color: "transparent" }}>-----</p>
                            </SparkTableCell>

                            <SparkTableCell
                              className="flex-row"
                              style={{ justifyContent: "center" }}
                            >
                              {rowItem.proposedValue}
                            </SparkTableCell>
                            <SparkTableCell
                              className="flex-row"
                              style={{ justifyContent: "center" }}
                            >
                              {getAttachmentText(rowItem.attachment)}
                            </SparkTableCell>
                            <SparkTableCell
                              className="flex-row"
                              style={{ justifyContent: "center" }}
                            >
                              <p>
                                {rowItem.status != " "
                                  ? t(
                                    `dealer-invited-statusENUM.${rowItem.status}`
                                  )
                                  : "-"}
                              </p>
                            </SparkTableCell>
                          </SparkTableRow>
                        ))}
                      </SparkTableBody>
                      <br />
                    </SparkTable>
                    {idsToSend.length > 0 && (
                      <button
                        className="blue"
                        onClick={(e) => {
                          e.preventDefault();
                          setSendMailModal(true);
                        }}
                      >
                        {t("send-mails")}
                      </button>
                    )}{" "}
                  </div>
                )}
              </CollapsibleSection>
            )}

            {showContract && scrapAdmin?.scrapInfo && (
              <CollapsibleSection title={t("material-about-contract")}>
                <div className="flex-column margin-topbottom-1">
                  <CTAInfoComponent>
                    <div className="flex-row align-center" style={{ gap: 10 }}>
                      <SparkIcon
                        noPadding
                        icName="lightbulb-attention"
                        pallete="primary"
                      />
                      <p>{t("cta-info.section-auto-contract")}</p>
                    </div>
                  </CTAInfoComponent>
                  <label htmlFor="material-dealer-contracted">
                    {t("material-dealer-contracted")}
                  </label>
                  <select
                    id="material-dealer-contracted"
                    {...register("scrapInfo.contractDealer", {
                      required: false,
                    })}
                    disabled={isContractDealerDisabled}
                    onChange={(event) => {
                      handleContractDealerChange(event);
                    }}
                  >
                    <option></option>
                    {dealersInvited
                      ?.filter((dealer) => dealer.status === "WINNER")
                      .map((dealer) => (
                        <option key={dealer.id} value={dealer.id}>
                          {dealer.legalName} - {dealer.tradingName}
                        </option>
                      ))}
                  </select>
                  {errors.scrapInfo?.contractDealer && (
                    <span>{t("error-input-required")}</span>
                  )}
                </div>

                <div className="flex-column margin-topbottom-1">
                  <label htmlFor="material-contract-date">
                    {t("material-contract-date")}
                  </label>

                  <Controller
                    name="scrapContract.contractDate"
                    control={control}
                    render={({ field }) => (
                      <input
                        {...field}
                        value={field.value ? field.value.split("T")[0] : ""}
                        placeholder="Material Contract Date"
                        type="date"
                        id="material-contract-date"
                        onChange={(e) => {
                          field.onChange(e);
                          handleCalculateValidateDate(e.target.value);
                        }}
                      />
                    )}
                  />

                  {errors.scrapContract?.contractDate && (
                    <span>{t("error-input-required")}</span>
                  )}
                </div>

                <div className="flex-column margin-topbottom-1">
                  {expiration && (
                    <Expiration
                      isValidateDateEnableToChange={true}
                      dto={expiration}
                      dataHandler={handleDataChange}
                      expirationDate={"expirationDate"}
                      warningPeriod={"warningPeriod"}
                      hasExpirationDate={"hasExpirationDate"}
                      hasExpirationDateInit={true}
                      disableExpirationCheckbox
                      showPreviousWarning={true}
                      expirationDateInit={expiration.expirationDate || ""}
                      warningPeriodInit={expiration.warningPeriod || 60}
                    />
                  )}

                  {errors.scrapContract?.expirationDocument?.expirationDate && (
                    <span>{t("error-input-required")}</span>
                  )}
                </div>

                <div className="flex-column margin-topbottom-1">
                  <label htmlFor="material-contract-value">
                    {t("material-contract-value")}
                    <span style={{ marginLeft: 5, color: "#9e9e9e" }}>
                      {`(${countryConfigEntity?.currencyName}/${selectedUnity || "unity"
                        })`}
                    </span>
                  </label>
                  <CurrencyInput
                    currency={countryConfigEntity?.currency}
                    locale={countryConfigEntity?.locale}
                    value={scrapAdmin?.scrapContract.contractValue}
                    defaultValue={contractValue}
                    onChangeValue={(event, originalValue, maskedValue) => {
                      setContractValue(maskedValue.toString());
                      setValue(
                        "scrapContract.contractValue",
                        maskedValue.toString(),
                        {
                          shouldValidate: true,
                        }
                      );
                    }}
                    InputElement={
                      <input
                        placeholder={t("material-contract-value")}
                        type="text"
                        id="material-contract-value"
                        {...register("scrapContract.contractValue", {
                          required: false,
                        })}
                        readOnly
                      />
                    }
                  />
                  {errors.scrapContract?.contractValue && (
                    <span>{t("error-input-required")}</span>
                  )}
                </div>

                <div className="flex-column margin-topbottom-1">
                  <label htmlFor="material-contract-index">
                    {t("material-contract-index")}
                  </label>
                  <input
                    placeholder={t("material-contract-index")}
                    type="text"
                    id="material-contract-index"
                    {...register("scrapContract.contractIndex", {
                      required: false,
                    })}
                  />
                  {errors.scrapContract?.contractIndex && (
                    <span>{t("error-input-required")}</span>
                  )}
                </div>
              </CollapsibleSection>
            )}

            {(scrapAdmin?.scrapInfo.status == StatusEnum.CONTRACTED ||
              scrapAdmin?.scrapInfo.status == StatusEnum.OPERATING ||
              scrapAdmin?.scrapInfo.status == StatusEnum.FINISHED ||
              scrapAdmin?.scrapInfo.status == StatusEnum.CANCELED) &&
              scrapAdmin?.scrapInfo && (
                <CollapsibleSection title={t("material-about-operation-label")}>
                  <div className="flex-column">
                    <label htmlFor="material-operation-date">
                      {t("label-init-date")}
                    </label>
                    <input
                      type="date"
                      id="material-operation-date"
                      {...register("scrapInfo.operationDate", {
                        required: false,
                      })}
                    />
                    {errors.scrapInfo?.operationDate && (
                      <span>{t("error-input-required")}</span>
                    )}
                  </div>

                  <div className="flex-column">
                    <h4>{t("label-type-isFinal")}</h4>
                    <div className="flex-row radio-types">
                      <div className="flex-row">
                        <label
                          style={{ margin: "10px 0px" }}
                          htmlFor="recipient-radio"
                        >
                          <input
                            type="radio"
                            id="recipient-radio"
                            value="true"
                            onChange={(e) => {
                              setOperationRecipientData("");
                              handleRadioOperationRecipientChange(true);
                            }}
                            checked={operationRecipient === true}
                          />
                          {t("label-contracted-company")}
                        </label>
                      </div>
                      <div className="flex-row">
                        <label
                          style={{ margin: "10px" }}
                          htmlFor="other-recipient"
                        >
                          <input
                            type="radio"
                            id="other-recipient"
                            value="false"
                            onChange={() =>
                              handleRadioOperationRecipientChange(false)
                            }
                            checked={operationRecipient === false}
                          />
                          {t("label-other")}
                        </label>
                      </div>
                    </div>
                  </div>

                  {!operationRecipient && (
                    <div>
                      <ScrapDealerInputAutocomplete
                        isSingleSelect
                        onChange={(data) => {
                          setOperationRecipientData(data[0] || "");
                          const scrapDealerInfo = {
                            id: data[0].id,
                            name: data[0].legalName,
                            MTRcode: data[0]?.mtrCode || "",
                            nationalRegister: data[0].nationalRegister,
                          };
                          setValue(
                            "scrapInfo.finalDestination",
                            scrapDealerInfo
                          );
                          trigger("scrapInfo.finalDestination");
                        }}
                        placeholder={t("label-type-isFinal")}
                        defaultValue={
                          finalDestination
                            ? [
                              {
                                legalName: finalDestination.name,
                                mtrCode: finalDestination.MTRcode,
                              },
                            ]
                            : []
                        }
                      />
                    </div>
                  )}

                  <div className="flex-column">
                    <h4>{t("label-type-isCarrier")}</h4>
                    <div className="flex-row radio-types">
                      <div className="flex-row">
                        <label
                          style={{ margin: "10px 0px" }}
                          htmlFor="carrier-radio"
                        >
                          <input
                            type="radio"
                            id="carrier-radio"
                            value="true"
                            onChange={(e) => {
                              setOperationCarrierData("");
                              handleRadioOperationCarrierChange(true);
                            }}
                            checked={operationCarrier === true}
                          />
                          {t("label-contracted-company")}
                        </label>
                      </div>
                      <div className="flex-row">
                        <label
                          style={{ margin: "10px" }}
                          htmlFor="other-carrier"
                        >
                          <input
                            type="radio"
                            id="other-carrier"
                            value="false"
                            onChange={() =>
                              handleRadioOperationCarrierChange(false)
                            }
                            checked={operationCarrier === false}
                          />
                          {t("label-other")}
                        </label>
                      </div>
                    </div>
                  </div>

                  {!operationCarrier && (
                    <div>
                      <div className="flex-column margin-topbottom-1">
                        <label htmlFor="material-carrier-name">
                          {t("label-carrier-name")}
                        </label>
                        <input
                          placeholder={t("label-carrier-name")}
                          type="text"
                          id="material-carrier-name"
                          {...register("scrapInfo.carrier.name", {
                            required: true,
                          })}
                        />
                        {errors.scrapInfo?.carrier?.name && (
                          <span>{t("error-input-required")}</span>
                        )}
                      </div>
                      <div className="flex-column margin-topbottom-1">
                        <label htmlFor="material-carrier-nationalRegister">
                          {generator?.nationalRegisterLabel}
                        </label>
                        <InputMask
                          mask={
                            countryConfigEntity?.nationalRegisterFormatting ||
                            "99.999.999/9999-99"
                          }
                          placeholder={
                            countryConfigEntity?.nationalRegisterFormatting
                          }
                          type="text"
                          id="nationalRegister"
                          {...register("scrapInfo.carrier.nationalRegister", {
                            required: true,
                          })}
                          inputRef={nationalRegisterRef}
                        />

                        {errors.scrapInfo?.carrier?.nationalRegister && (
                          <span>{t("error-input-required")}</span>
                        )}
                      </div>
                      <div className="flex-column margin-topbottom-1">
                        <label htmlFor="material-carrier-MTRcode">
                          {t("label-mtrCode") + " " + t("label-sigor")}
                        </label>
                        <input
                          placeholder={t("label-mtrCode")}
                          type="text"
                          id="material-carrier-MTRcode"
                          {...register("scrapInfo.carrier.MTRcode", {
                            required: true,
                          })}
                        />
                        {errors.scrapInfo?.carrier?.MTRcode && (
                          <span>{t("error-input-required")}</span>
                        )}
                      </div>
                    </div>
                  )}

                  <div className="flex-column">
                    <h4>{t("label-temporary-storage")}</h4>
                    <div className="flex-row radio-types">
                      <div className="flex-row">
                        <label
                          style={{ margin: "10px 0px" }}
                          htmlFor="temporary-storage-radio"
                        >
                          <input
                            type="radio"
                            id="temporary-storage-radio"
                            value="true"
                            onChange={(e) => {
                              setOperationTemporaryStorageData("");
                              handleRadioOperationTempStorageChange(true);
                            }}
                            checked={operationTemporaryStorage === true}
                          />
                          {t("label-contracted-company")}
                        </label>
                      </div>
                      <div className="flex-row">
                        <label
                          style={{ margin: "10px" }}
                          htmlFor="other-temporary-storage"
                        >
                          <input
                            type="radio"
                            id="other-temporary-storage"
                            value="false"
                            onChange={() =>
                              handleRadioOperationTempStorageChange(false)
                            }
                            checked={operationTemporaryStorage === false}
                          />
                          {t("label-other")}
                        </label>
                      </div>
                    </div>
                  </div>

                  {!operationTemporaryStorage && (
                    <div>
                      <div className="flex-column margin-topbottom-1">
                        <label htmlFor="material-tempDealer-name">
                          {t("label-person")}
                        </label>
                        <input
                          placeholder={t("label-person")}
                          type="text"
                          id="material-tempDealer-name"
                          {...register("scrapInfo.tempDealer.name", {
                            required: true,
                          })}
                        />
                        {errors.scrapInfo?.tempDealer?.name && (
                          <span>{t("error-input-required")}</span>
                        )}
                      </div>
                      <div className="flex-column margin-topbottom-1">
                        <label htmlFor="material-tempDealer-nationalRegister">
                          {generator?.nationalRegisterLabel}
                        </label>
                        <InputMask
                          mask={
                            countryConfigEntity?.nationalRegisterFormatting ||
                            "99.999.999/9999-99"
                          }
                          placeholder={
                            countryConfigEntity?.nationalRegisterFormatting
                          }
                          type="text"
                          id="nationalRegister"
                          {...register(
                            "scrapInfo.tempDealer.nationalRegister",
                            {
                              required: true,
                            }
                          )}
                          inputRef={nationalRegisterRef}
                        />

                        {errors.scrapInfo?.tempDealer?.nationalRegister && (
                          <span>{t("error-input-required")}</span>
                        )}
                      </div>
                      <div className="flex-column margin-topbottom-1">
                        <label htmlFor="material-tempDealer-MTRcode">
                          {t("label-mtrCode") + " " + t("label-sigor")}
                        </label>
                        <input
                          placeholder={t("label-mtrCode")}
                          type="text"
                          id="material-tempDealer-MTRcode"
                          {...register("scrapInfo.tempDealer.MTRcode", {
                            required: true,
                          })}
                        />
                        {errors.scrapInfo?.tempDealer?.MTRcode && (
                          <span>{t("error-input-required")}</span>
                        )}
                      </div>
                    </div>
                  )}
                </CollapsibleSection>
              )}

            <CollapsibleSection title={t("label-others")}>
              <div className="form-fields flex-column">
                <div className="flex-column">
                  <label htmlFor="observations">
                    {t("label-general-observations")}
                  </label>
                  <textarea
                    placeholder={t("placeholder.observations")}
                    id="observations"
                    {...register("observations.observations")}
                  />
                </div>
              </div>
            </CollapsibleSection>

            <div className="flex-row buttons-section">
              <button
                disabled={
                  !scrapId ||
                  scrapAdmin?.scrapInfo.status == StatusEnum.FINISHED ||
                  scrapAdmin?.scrapInfo.status == StatusEnum.CANCELED ||
                  scrapAdmin?.scrapInfo.status == StatusEnum.DISAPPROVED
                }
                className="neutral-white"
                onClick={() => setConfirmationModalOpen(true)}
                type="button"
              >
                {t("label-cancel")}
              </button>
              <button
                className="neutral-white"
                onClick={() =>
                  navigate(`/scrap-generators-details/${id}/scraps`)
                }
                type="button"
              >
                {t("label-back")}
              </button>
              <button
                className="blue"
                type="submit"
                disabled={
                  scrapAdmin?.scrapInfo.status == StatusEnum.DISAPPROVED ||
                  isDisabled
                }
              >
                {t("label-save")}
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  } else {
    navigate("/page-not-found");
    return <></>;
  }
};

export default ScrapForm;
